import React from 'react'
import styled from '@emotion/styled'

import { Loader } from 'shared/ui'

import Customer from './Customer'
import RecentConversations from './RecentConversations'
import CustomProfile from './CustomProfile'
import Integrations from './Integrations'

const CardContainer = styled('div')`
  margin-bottom: 320px;
`

const InAppCardsView = ({
  customerEmail,
  customerId,
  integrations,
  isLoading,
  loadEmailMarketingIntegrations,
  showCustomProfile,
  ticketId,
}) => {
  if (ticketId === 'new') return null
  if (!customerId || isLoading) return <Loader className="grui mt-24" />
  return (
    <CardContainer>
      <Customer />
      <RecentConversations />
      {showCustomProfile && (
        <CustomProfile
          customerId={customerId}
          id={`custom-profile-${customerId}`}
          key={`custom-profile-${customerId}`}
        />
      )}
      {customerEmail && (
        <Integrations
          customerId={customerId}
          key={`integrations-${customerId}`}
          integrations={integrations}
          loadEmailMarketingIntegrations={loadEmailMarketingIntegrations}
        />
      )}
    </CardContainer>
  )
}

export default InAppCardsView
